/* eslint-disable eqeqeq */
import { FC, useState, useMemo, useEffect, useCallback } from 'react'
import { useAppSelector } from '../../store/hooks'
import {
  GuideDispatchField,
  FormSelect,
  FormText,
  GuidesDispatchTables,
  MainPage,
  PageTitle,
  PaginationFooter,
  PrimaryButton,
  CreateDataDispatch,
  ModalLoading,
  ConfirmModalStatus,
  DispatchPrintModal,
  FormDatePicker,
  SecondaryButton,
} from '../../components'
import {
  getGuideDispatchs,
  saveDispatchs,
} from '../../services/DispatchServices'
import {
  DispatchGuideDto,
  DispatchInterface,
  ManifestDetail,
  RouteInterface,
} from '../../interfaces'
import {
  ChevronRightIcon,
  MagnifyingGlassIcon,
} from '@heroicons/react/20/solid'
import { getRoute } from '../../services/RouteServices'
import moment from 'moment'
import classNames from 'classnames'
import { Icon } from '@iconify/react'
import broomIcon from '@iconify/icons-mdi/broom'

const CreateDispatch: FC = () => {
  const user = useAppSelector((state) => state.user)
  const [page, setPage] = useState(0)
  const [search, setSearch] = useState('')
  const [guideDisptachs, setGuideDispatchs] = useState<DispatchGuideDto[]>([])
  const [selecteds, setSelecteds] = useState<DispatchGuideDto[]>([])

  const [registersNumber, setRegistersNumber] = useState(10)
  const [selectNext, setSelectNext] = useState(false)
  const [save, setSave] = useState(false)

  const [sale1Dispath, setSale1Dispath] = useState('')
  const [sale2Dispath, setSale2Dispath] = useState('')
  const [sale3Dispath, setSale3Dispath] = useState('')

  const [route, setRoute] = useState('')
  const [transport, setTransport] = useState('')
  const [driver, setDriver] = useState('')

  // 1. Estado inicial de los FormDatePicker en null
  const [minDate, setMinDate] = useState<Date | null>(null)
  const [maxDate, setMaxDate] = useState<Date | null>(null)

  const [listRouteDispath, setListRouteDispath] = useState<RouteInterface[]>([])

  let [loading, setLoading] = useState(false)
  let [loadingStatus, setLoadingStatus] = useState(
    ConfirmModalStatus.PROCESSING
  )
  let [loadingTitle, setLoadingTitle] = useState('Cargando...')
  const [openPrintModal, setOpenPrintModal] = useState(false)

  const [masterShipmentHeaderCode, setMasterShipmentHeaderCode] = useState('')

  const [sortBy, setSortBy] = useState({
    field: GuideDispatchField.DATECREATE,
    asc: false,
  })

  const filteredDispatch = useMemo(() => {
    const tokens = search?.toLowerCase().split(' ')
    return guideDisptachs.filter((disptach) => {
      return tokens.every((token) => {
        return (
          disptach.numGuia?.toString().toLowerCase().includes(token) ||
          disptach.origen.toLowerCase().includes(token) ||
          moment(disptach.fechaCreacion)
            ?.format('DD/MM/YYYY')
            ?.includes(token) ||
          disptach.ciudadDestino?.toString().toLowerCase().includes(token)
        )
      })
    })
  }, [guideDisptachs, search])

  const paginatedDispatch = useMemo(() => {
    const orderedDispatch = filteredDispatch.sort((a, b) => {
      if (sortBy.field == GuideDispatchField.NUM_GUIDE) {
        return sortBy.asc
          ? a.numGuia.localeCompare(b.numGuia)
          : b.numGuia.localeCompare(a.numGuia)
      } else if (sortBy.field == GuideDispatchField.ORIGEN) {
        return sortBy.asc
          ? a.origen.localeCompare(b.origen)
          : b.origen.localeCompare(a.origen)
      } else if (sortBy.field == GuideDispatchField.DATECREATE) {
        return sortBy.asc
          ? (a.fechaCreacion.localeCompare(b.fechaCreacion ?? '') ?? false)
          : (b.fechaCreacion.localeCompare(a.fechaCreacion ?? '') ?? false)
      } else if (sortBy.field == GuideDispatchField.SALE) {
        return sortBy.asc
          ? (a?.sealNumber?.localeCompare(b?.sealNumber ?? '') ?? -1)
          : (b?.sealNumber?.localeCompare(a?.sealNumber ?? '') ?? -1)
      } else if (sortBy.field == GuideDispatchField.PESO) {
        return sortBy.asc
          ? (a.peso ?? 0) - (b.peso ?? 0)
          : (b.peso ?? 0) - (a.peso ?? 0)
      }
      return 0
    })

    const start = page * registersNumber
    const end = start + registersNumber

    return orderedDispatch.slice(start, end)
  }, [filteredDispatch, sortBy, page, registersNumber])

  const handleSortByChange = (field: GuideDispatchField) => {
    if (sortBy.field == field) {
      setSortBy({ ...sortBy, asc: !sortBy.asc })
    } else {
      setSortBy({ field, asc: true })
    }
  }

  // 3. Lógica de búsqueda (onSearchShipments)
  const onSearchShipments = useCallback(async (showLoading: boolean = true) => {
    const customercode = '' + user?.client?.accountCode
    const customerId = '' + user?.client?.id
    if (!customercode || !customerId) return

    if (showLoading) {
      setLoadingStatus(ConfirmModalStatus.PROCESSING)
      setLoadingTitle('Cargando...')
      setLoading(true)
    }

    const fechaDesde = minDate
      ? moment(minDate).format('YYYY-MM-DD')
      : undefined
    const fechaHasta = maxDate
      ? moment(maxDate).format('YYYY-MM-DD')
      : undefined

    const shipments = await getGuideDispatchs(
      customercode,
      customerId,
      fechaDesde,
      fechaHasta
    )

    if (!shipments?.didError) {
      setGuideDispatchs(shipments?.model as DispatchGuideDto[])
      if (showLoading) setLoading(false)
    } else {
      setLoadingStatus(ConfirmModalStatus.ERROR)
      setLoadingTitle('Error: ' + shipments?.errorMessage)
      setLoading(true)
    }
  }, [user?.client?.accountCode, user?.client?.id, minDate, maxDate])

  // 5. Limpieza de useEffects: Carga inicial consolidada
  useEffect(() => {
    const fetchRoute = async () => {
      const shipments = await getRoute('' + user?.client?.BuCodeSource)
      if (!shipments?.didError) {
        setListRouteDispath(shipments?.model as RouteInterface[])
      }
    }
    fetchRoute()
    onSearchShipments() // Se ejecuta carga inicial
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.client?.id])

  useEffect(() => {
    if (save) {
      setLoadingStatus(ConfirmModalStatus.PROCESSING)
      setLoadingTitle('Cargando...')
      setLoading(true)
      let manifestDetail = [] as ManifestDetail[]
      selecteds?.forEach((x) => {
        for (let i = 0; i < (x.totalPiezas ?? 0); i++) {
          manifestDetail.push({
            serviceCode: x.servicioID?.toString() ?? '',
            bUCodeSource: x.origen,
            shipmentNumber: x.numGuia,
            measureUnitTypeID: null,
            pieceNumber: i + 1,
            statusID: 31,
            locationDestinationCode: x.ciudadDestino,
            locationConsigneeID: null,
            lineSeqNumber: null,
            difference: 0,
            totalPieces: x.totalPiezas ?? 0,
            heigh: 0,
            width: 0,
            lenght: 0,
            physicalWeight: x.peso / (x.totalPiezas ?? 0),
            dimensionalWeight: 0,
            barCode: undefined,
            creationUser: user?.user?.login ?? 'ccw',
          } as ManifestDetail)
        }
      })

      var destiantionRoute = listRouteDispath.find((x) => x.routeID == route)

      const array = {
        routeID: route,
        transportID: transport,
        driver1ID: driver,
        seal1: sale1Dispath,
        seal2: sale2Dispath,
        seal3: sale3Dispath,
        manifestDetail: manifestDetail as ManifestDetail[],
        statusID: 35,
        manifestTypeID: 1,
        accountID: user?.client?.id,
        accountSiteID:
          user?.client?.accountSiteID === 0
            ? undefined
            : user?.client?.accountSiteID,
        bUCodeSource: user?.client?.BuCodeSource ?? '',
        buCodeDestination: destiantionRoute?.buCodeConsignee,
        creationUser: user?.user?.login ?? 'ccw',
        shippingMethodID: 10,
        shipperName:
          destiantionRoute?.buSourceName + '-' + destiantionRoute?.buCodeSource,
        consigneeName: destiantionRoute?.buConsigneeName,
        isQRCode: false,
        masterShipmentAssociationList: [],
      } as DispatchInterface

      const saveDispatcherApi = async () => {
        let response = await saveDispatchs(array)

        if (!response?.didError) {
          var data = response?.model
          setMasterShipmentHeaderCode(data?.masterShipmentHeaderCode ?? '')
          setLoadingStatus(ConfirmModalStatus.PRINT)
          setLoadingTitle(
            `¡Se registro el despacho Nº ${data?.masterShipmentHeaderCode} con exito!`
          )
          setSelecteds([])
          setLoading(true)
          setSave(false)
          setSelectNext(false)
          await onSearchShipments(false)
        } else {
          setLoadingStatus(ConfirmModalStatus.ERROR)
          setLoadingTitle(`Error: ${response.errorMessage}`)
          setLoading(true)
          setSave(false)
        }
      }
      saveDispatcherApi()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [save])

  const handleClearFilters = () => {
    setSearch('')
    setSelecteds([])
    setPage(0)
    setMaxDate(null)
    setMinDate(null)
  }

  return (
    <MainPage>
      {/* 4. Reubicación del botón "Siguiente" junto al título */}
      <div className="flex justify-between items-center w-full mb-6">
        <PageTitle title="Creación de manifiesto de despacho" />
      </div>

      <div className="flex flex-1 flex-col">
        {!selectNext && (
          <div>
            <div className="flex flex-1 justify-between gap-2 md:gap-6 flex-col-reverse md:flex-row">
              <div className="flex flex-col sm:flex-row gap-4 w-full flex-1">
                <div className="w-full">
                  <FormText
                    id="search"
                    name="search"
                    value={search}
                    label="Buscador"
                    className=""
                    labelClassname=" mb-1"
                    placeholder="Búsqueda rápida de guía..."
                    onChange={(e) => {
                      setSearch(e.target.value)
                      setPage(0)
                    }}
                  />
                </div>
              </div>
              <div className="flex flex-col lg:flex-row items-end gap-2 w-full xl:w-3/5">
                <div className="flex flex-col sm:flex-row gap-4 w-full flex-1">
                  <div className="w-full">
                    <FormDatePicker
                      id="shipments-date-from"
                      name="shipments-date-from"
                      label="Desde"
                      labelClassname="mb-1"
                      useRange={false}
                      maxDate={maxDate ?? undefined}
                      value={{
                        startDate: minDate,
                        endDate: minDate,
                      }}
                      toggleClassName={(oldClassname) =>
                        classNames(oldClassname, 'text-main-600')
                      }
                      onChange={(e) => {
                        const date = e?.startDate
                          ? moment(e.startDate).toDate()
                          : null
                        setMinDate(date)
                      }}
                      configs={{ shortcuts: {} }}
                    />
                  </div>

                  <div className="w-full">
                    <FormDatePicker
                      id="shipments-date-to"
                      name="shipments-date-to"
                      label="Hasta"
                      labelClassname="mb-1"
                      useRange={false}
                      minDate={minDate ?? undefined}
                      value={{
                        startDate: maxDate,
                        endDate: maxDate,
                      }}
                      toggleClassName={(oldClassname) =>
                        classNames(oldClassname, 'text-main-600')
                      }
                      onChange={(e) => {
                        const date = e?.startDate
                          ? moment(e.startDate).toDate()
                          : null
                        setMaxDate(date)
                      }}
                      configs={{ shortcuts: {} }}
                    />
                  </div>
                </div>

                {/* 2. Integración de botón "Buscar" */}
                <div className="flex w-full sm:w-auto h-[42px] ">
                  <SecondaryButton
                    className="btn-limpiar mr-2"
                    title="Limpiar filtros"
                    onClick={handleClearFilters}
                  >
                    <Icon icon={broomIcon} className="w-5 h-5" width="24" />
                  </SecondaryButton>
                  <PrimaryButton onClick={() => onSearchShipments(true)}>
                    Buscar <MagnifyingGlassIcon className="w-5 h-5 ml-2" />
                  </PrimaryButton>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center mt-12 mb-1">
              <div className="flex items-center text-xs">
                <span>Mostrar</span>
                <div className="inline mx-1">
                  <FormSelect
                    id="registersNumber"
                    name="registersNumber"
                    label=""
                    selected={registersNumber}
                    options={[10, 25, 50, 100]}
                    className="!w-20 !h-8 !px-2"
                    optionString={(option) => option.toString()}
                    onSelectOption={(option) => setRegistersNumber(option)}
                  />
                </div>
                <span>registros</span>
              </div>

              {!selectNext && (
                <PrimaryButton
                  type="button"
                  disabled={selecteds.length === 0}
                  className="px-4 whitespace-nowrap"
                  onClick={() => setSelectNext(true)}
                >
                  Siguiente{' '}
                  <ChevronRightIcon
                    className="h-5 w-5 ml-2"
                    aria-hidden="true"
                  />
                </PrimaryButton>
              )}
            </div>
          </div>
        )}

        {!selectNext && (
          <div className="flex flex-1 flex-col">
            <GuidesDispatchTables
              sortBy={sortBy}
              dispatchGuides={paginatedDispatch}
              selectedGuide={selecteds}
              selectedAll={
                selecteds.length == filteredDispatch.length &&
                selecteds.length > 0
              }
              onChangeSortBy={handleSortByChange}
              onSelectGuide={(guides) => {
                if (selecteds.includes(guides)) {
                  setSelecteds(selecteds.filter((s) => s !== guides))
                } else {
                  setSelecteds([...selecteds, guides])
                }
              }}
              onSelectAll={() => {
                if (selecteds.length === filteredDispatch.length) {
                  setSelecteds([])
                } else {
                  setSelecteds([...filteredDispatch])
                }
              }}
            />
            <PaginationFooter
              currentPage={page}
              itemsPerPage={registersNumber}
              totalItems={filteredDispatch.length}
              onPageChange={setPage}
            />
          </div>
        )}

        {selectNext && (
          <div className="flex flex-1 flex-col">
            <CreateDataDispatch
              setSelectNext={setSelectNext}
              setSave={setSave}
              setSale1Dispath={setSale1Dispath}
              setSale2Dispath={setSale2Dispath}
              setSale3Dispath={setSale3Dispath}
              saveDispath={save}
              setRoute={setRoute}
              setTransport={setTransport}
              setDriver={setDriver}
            />
          </div>
        )}
      </div>

      <ModalLoading
        open={loading}
        title={loadingTitle}
        status={loadingStatus}
        setOpen={setLoading}
        onPrint={() => {
          setOpenPrintModal(true)
          setLoading(false)
        }}
      />
      <DispatchPrintModal
        open={openPrintModal}
        numberDispatch={masterShipmentHeaderCode}
        setOpen={setOpenPrintModal}
      />
    </MainPage>
  )
}

export default CreateDispatch
